type EventDetail = Record<string, string>;

interface CustomEventModule {
    createCustomEvent: (eventType: string, detail: EventDetail) => CustomEvent;
    dispatchEvent: (handler: EventTarget, event: CustomEvent) => boolean;
}

export function createCustomEventModule(): CustomEventModule {
    const createCustomEvent = (
        eventType: string,
        detail: EventDetail,
    ): CustomEvent =>
        new CustomEvent(eventType, {
            bubbles: true,
            cancelable: true,
            detail,
        });

    const dispatchEvent = (handler: EventTarget, event: CustomEvent): boolean =>
        handler.dispatchEvent(event);

    return {
        createCustomEvent,
        dispatchEvent,
    };
}
